// extracted by mini-css-extract-plugin
module.exports = {"separator":"DividerWithLabel_separator__30Uqn"};